<div class="dialog">
  <div class="row">
    <div class="col-md-6">
      <h2 class="dialog-header">{{ modalTitle | translate }}</h2>
    </div>
    <div class="col-md-6 align-right">
      <button
        type="button"
        class="btn btn-xs btn-success"
        (click)="addFacility()"
        *ngIf="listMode && permissions.canCreate"
      >
        <i class="fa fa-plus"></i> {{ 'NEW' | translate }}
      </button>
      <button type="button" class="btn btn-xs" (click)="showFacilities()" *ngIf="detailMode">
        <i class="fa fa-angle-left"></i> {{ 'BACK' | translate }}
      </button>

      <span class="dialog-close" (click)="close()">
        <i class="fa fa-close"></i>
      </span>
    </div>
  </div>

  <div class="dialog-content">
    <div *ngIf="listMode">
      <div *ngIf="permissions.canList">
        <app-facility-list
          [facilities]="facilities"
          [meta]="meta"
          [loadingFacilities]="loadingFacilities"
          [defaultLanguage]="defaultLanguage"
          (selectedFacility)="onSelectedFacility($event)"
        ></app-facility-list>
      </div>
      <div *ngIf="!permissions.canList">INVALID ACCESS</div>
    </div>

    <div *ngIf="detailMode">
      <app-facility-detail
        [facility]="facility"
        [mode]="mode"
        [defaultLanguage]="defaultLanguage"
        [additionalLanguages]="additionalLanguages"
        [isModal]="true"
        (savedFacility)="onSavedFacility($event)"
        (canceledFacility)="onCanceledFacility()"
      ></app-facility-detail>
    </div>
  </div>
</div>
